<template>
  <div class="header__main-container">
    <div class="header-container">
      <img :src="`${basePath}${companySetting.logo ? companySetting.logo.path : ''}`" alt="" class="header-logo" />
      <HeaderMenuItem
        v-for="(menu, index) in options.listMenus.items" :key="index"
        :title="menu.title"
        :index="index"
        @onMenuItemClicked="onMenuItemClicked"
        :class="{ active: $route.path.startsWith(menu.path) }"
        :isVisible="isAccessible(menu.permissionIds) && menu.isVisible"/>
        <b-dropdown class="custom-dropdown" boundary="viewport" v-if="options.dropDownMenus.items.length > 0" no-caret >
          <template #button-content>
            <div class="custom-dropwdown_button-content">More<v-icon name="caret-down" class="ml-2"/></div>
          </template>
          <b-dropdown-item
            v-for="(dropDownMenu, index) in options.dropDownMenus.items" :key="index"
            @click="dropDownMenuClicked(index)">
            {{ dropDownMenu.title.toUpperCase() }}
          </b-dropdown-item>
        </b-dropdown>
      <HeaderDropDown @onLogoutUser="onLogoutUser"/>
    </div>
    <HeaderSubMenu
      :subMenus="accessibleMenus[activeMenuIndex].children"
      v-if="accessibleMenus[activeMenuIndex] && accessibleMenus[activeMenuIndex].children && accessibleMenus[activeMenuIndex].children.length > 0"
      :key="subMenuKey"/>
  </div>
</template>

<script>
import HeaderMenuItem from './HeaderMenuItem'
import HeaderSubMenu from './HeaderSubMenu'
import HeaderDropDown from './HeaderDropDown'
import menus from './nav'
import Access from '../../mixins/utils/Access'
export default {
  menus,
  components: {
    HeaderMenuItem,
    HeaderSubMenu,
    HeaderDropDown
  },
  mixins: [ Access ],
  created() {
    // const currentIndex = this.accessibleMenus.findIndex(e => this.$route.path.startsWith(e.path))
    // if(currentIndex) {
    //   this.activeMenuIndex = currentIndex
    // }
  },
  data() {
    return {
      // activeMenuIndex: 0,
      subMenuKey: 0,
      menus: [...this.$options.menus],
      basePath: process.env.VUE_APP_PUBLIC_PHOTO_URL,
      windowWidth: window.innerWidth,
      options: {
        dropDownMenus: {
          items: []
        },
        listMenus: {
          items:[ ...this.$options.menus ]
        }
      }
    }
  },
  methods: {
    onMenuItemClicked($event) {
      this.subMenuKey += 1
      // this.activeMenuIndex = $event
     //home
      if($event === 0) {
        this.$router.replace('/')
      }
      else {
        //push to first child of menu
        if(this.accessibleMenus[$event].children.length > 0) {
          const subMenu = this.accessibleMenus[$event].children.find(subMenu => this.isAccessible(subMenu.permissionIds) === true);
          this.$router.replace(subMenu.path)
        }
      }
    },
    dropDownMenuClicked(index) {
      const dropDownMenu = this.options.dropDownMenus.items[index]
      if(dropDownMenu.children.length > 0) {
        const subMenu = dropDownMenu.children.find(subMenu => this.isAccessible(subMenu.permissionIds) === true);
        this.$router.replace(subMenu.path)
       }
    },
    onLogoutUser() {
      this.$emit('onLogoutUser')
    },
    filterMenus() {
      const { listMenus, dropDownMenus } = this.options
      if(this.cutOffIndex != 0) {
        if(this.accessibleMenus) {
          listMenus.items = this.accessibleMenus.slice(0, this.cutOffIndex);
          dropDownMenus.items = this.accessibleMenus.slice(listMenus.items.length, this.accessibleMenus.length);
        }
      }
      else {
        listMenus.items = this.accessibleMenus
        dropDownMenus.items = []
      }
      this.subMenuKey += 1
    },
    onResize() {
      this.windowWidth = window.innerWidth
      this.filterMenus()
    },
  },
  computed: {
    companySetting() {
      return this.$store.state.companySetting ?? null
    },
    cutOffIndex() {
      //calculate the max index of menus on the viewport
      let canvas = document.createElement("canvas")
      let context = canvas.getContext('2d')
      context.font = "bold 12px sans-serif"
      let width = 0
      let cutOffIndex = 0
      if(this.accessibleMenus) {
        this.accessibleMenus.every(menu => {
          width += (context.measureText(menu.title.toUpperCase()).width + 20)
          if((width + 300) > this.windowWidth) {
            cutOffIndex = this.accessibleMenus.indexOf(menu)
            return false
          }
          return true
        })
      }
      return cutOffIndex
    },
    accessibleMenus() {
      return this.menus.filter(menu => this.isAccessible(menu.permissionIds) && menu.isVisible)
    },
    activeMenuIndex: {
      get() {
        return this.accessibleMenus.findIndex(e => this.$route.path.startsWith(e.path))
      },
      set(newValue) {
        return newValue
      }
    }
  },
  watch:{
    accessibleMenus (values){
      this.filterMenus()
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
      this.filterMenus()
    })
  },

}
</script>

<style lang="scss" scoped>

  .header__main-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    position: sticky;
    top: 0;
    z-index: 99;
  }

  .header-container {
    width: 100%;
    max-height: 40px;
    background-color: rgb(75, 74, 74);
    // background-color: rgb(35, 4, 107);
    display: flex;
    align-items: center;
    padding: 0 20px;
    margin: 0;
    position: relative;
  }

  .header-logo {
    height: 35px;
    width: 35px;
    margin-right: 20px;
  }

</style>